import React from 'react';

export function Season({heading, icon, high, low, precipitation}) {
    return (
        <div className="weather__item">
            <span className={`weather__item__icon weather__item__icon--${icon}`} />
            <div className="text">
                <h4>{heading}</h4>
                <div>
                    <p className="data"> {high} </p>
                    <p className="data"> {low} </p>
                    <p className="data"> {precipitation} </p>
                </div>
            </div>
        </div>
    );
}

export default Season;